module.exports = {
  siteTitle: "Netcreative - Your website is your business", // <title>
  shortSiteTitle: "Netcreative", // <title> ending for posts and pages
  siteDescription: "New Jersey-based hybrid web app development",
  siteUrl: "https://netcreative.org",
  backgroundImg: "techlogos.png",
  // pathPrefix: "",
  siteImage: "preview.jpg",
  siteLanguage: "en",

  /* author */
  authorName: "William Pope",
  authorTwitterAccount: "williamrpope",

  /* info */
  headerTitle: "William Pope",
  headerSubTitle: "portfolio of web work",

  /* manifest.json */
  manifestName: "Netcreative - we build websites so you don't have to",
  manifestShortName: "Netcreative", // max 12 characters
  manifestStartUrl: "/index.html",
  manifestBackgroundColor: "white",
  manifestThemeColor: "#666",
  manifestDisplay: "standalone",

  // gravatar
  // Use your Gravatar image. If empty then will use src/images/jpg/avatar.jpg
  // Replace your email adress with md5-code.
  // Example https://www.gravatar.com/avatar/g.strainovic@gmail.com ->
  // gravatarImgMd5: "https://www.gravatar.com/avatar/1db853e4df386e8f699e4b35505dd8c6",
  gravatarImgMd5: "",

  // social
  authorSocialLinks: [
    { name: "github", url: "https://github.com/billp72" },
    { name: "linkedin", url: "https://www.linkedin.com/in/william-r-pope" },
    { name: "facebook", url: "https://www.facebook.com/billy.pope.165" }
  ]
};
